import { useUserContext } from '@/auth/UserContext';
import {
  getCurrentStudyYearStart,
  parseStudyYearStart,
} from '@/pages/Overview/period';

export const useStudyYearStart = (): number => {
  const { user } = useUserContext();

  return (
    parseStudyYearStart(user?.studyYear?.name) ?? getCurrentStudyYearStart()
  );
};
